module.exports = __webpack_public_path__ + "img/kettle.7a13da5.webp";